import React, { ElementType, FC } from "react";
import classNames from "classnames";

/**
 * Proposal for a Text component. We should consider making this an
 * official Kaleidoscope component
 */

interface ITextProps {
  /**
   * Sepcify the html element rendered by the text. Defaults to a `<span>`
   */
  as?: ElementType;
  size?: TextSize;
  /**
   * Truncates text overflow with ellipsis
   */
  truncate?: boolean;
  tone?: TextTone;
  weight?: TextWeight;
  align?: TextAlign;
  className?: string;
}

export enum TextWeight {
  Normal = "normal",
  Strong = "strong",
}

export enum TextSize {
  Auto = "auto",
  Small = "small",
  Medium = "medium",
  Large = "large",
  XLarge = "xlarge",
  XXLarge = "xxlarge",
}

export enum TextAlign {
  Start = "start",
  Center = "center",
}

export enum TextTone {
  Auto = "auto",
  Normal = "normal",
  Secondary = "secondary",
  Primary = "primary",
}

const Heading: FC<ITextProps> = ({
  children,
  as: Component,
  size = TextSize.Medium,
  weight = TextWeight.Normal,
  align = TextAlign.Start,
  tone = TextTone.Normal,
  truncate,
  className,
}) => {
  const TextElement = Component || `span`;

  return (
    <TextElement
      className={classNames(
        className,
        "kl-text",
        `kl-text--size-${size}`,
        `kl-text--weight-${weight}`,
        `kl-text--align-${align}`,
        `kl-text--tone-${tone}`,
        {
          "kl-text--truncate": truncate,
        },
      )}
    >
      {children}
    </TextElement>
  );
};

export default Heading;
